// extracted by mini-css-extract-plugin
module.exports = {"table":"DeliverySection_table__hwl8S","cell":"DeliverySection_cell__WHxNI","temperatureTagFirst":"DeliverySection_temperatureTagFirst__fTeA3"};